export default {
    demands       : [],
    loading       : false,
    saving        : false
};
